import { api } from './client';

export interface ChannelTalkMemberProfile {
  [key: string]: string | number | boolean | null | undefined;
}

export interface ChannelTalkMemberResponse {
  configured: boolean;
  serviceId: string;
  memberId: string | null;
  memberHash: string | null;
  profile: ChannelTalkMemberProfile;
}

export const channelTalkApi = {
  getMember: async (): Promise<ChannelTalkMemberResponse | null> => {
    try {
      return await api.get<ChannelTalkMemberResponse>('/api/v1/channel-io/member');
    } catch {
      return null;
    }
  },
};
